import React from "react";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { handleGetCatalogAreaRequest } from "store/modules/Catalog/thunk.store";
import { handleGetWorkingAreaRequest } from "store/modules/Logistics/thunk.store";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { useAuth } from "context/AuthContext";
import CardProductCovered from "components/CardProductCovered";
import * as Styled from "./styles";
import { Checkbox } from "@mui/material";
import { grey } from "@mui/material/colors";
import {
  CoverageAreaProps,
  CoverageAreaSummary,
} from "store/modules/Logistics/types.store";

interface AccordionProductCoveredProps {
  product: CoverageAreaSummary;
  workingAreasId: string;
  handleOpenArea: (coverageAreaId: string) => Promise<void>;
  isMassEdit: boolean;
  handleMassEditData: (coverageArea: CoverageAreaSummary) => Promise<void>;
  massEditData: CoverageAreaProps[];
  gasDoPovo: boolean;
}

const AccordionProductCovered = ({
  product,
  workingAreasId,
  handleOpenArea,
  isMassEdit,
  handleMassEditData,
  massEditData,
  gasDoPovo,
}: AccordionProductCoveredProps) => {
  const dispatch = useAppDispatch();
  const { dealerId } = useAuth();
  const { coverageArea } = useAppSelector((state) => state.catalog);
  const workingArea = useAppSelector(
    (state) => state.logistics.workingAreaDetails[product.id],
  );

  const [expand, setExpand] = React.useState(false);

  const handleGetArea = async () => {
    if (!expand) {
      await Promise.all([
        dispatch(
          handleGetWorkingAreaRequest({
            coverageAreaId: product.id,
            dealerId,
            suppressGlobalSpinner: true,
          }),
        ).unwrap(),
        dispatch(
          handleGetCatalogAreaRequest({
            coverageAreaId: product.id,
            dealerId,
          }),
        ).unwrap(),
      ]);
      setExpand(true);
    }
    setExpand(!expand);
  };

  const verifyCheckbox = () => {
    return (
      massEditData?.length > 0 &&
      massEditData?.some((item: CoverageAreaProps) => item.id === product.id)
    );
  };

  const handleChangeCheckbox = async (
    e: React.MouseEvent<HTMLButtonElement>,
  ) => {
    e.stopPropagation();
    await handleMassEditData(product);
  };

  return (
    <Accordion expanded={expand}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        onClick={() => handleGetArea()}
      >
        <Styled.ContainerTitle>
          {isMassEdit && (
            <Checkbox
              checked={verifyCheckbox()}
              onClick={handleChangeCheckbox}
              color={workingArea?.enabled === false ? "warning" : "primary"}
              sx={
                workingArea?.enabled !== false
                  ? undefined
                  : {
                      color: grey[300],
                      "&.Mui-checked": {
                        color: grey[300],
                      },
                    }
              }
            />
          )}
          <Typography
            color={
              workingArea?.enabled === false ? "text.disabled" : "text.primary"
            }
          >
            {product?.name}
          </Typography>
        </Styled.ContainerTitle>
      </AccordionSummary>
      <AccordionDetails style={{ padding: 0 }}>
        <CardProductCovered
          handleOpenArea={handleOpenArea}
          dealerSelected={workingAreasId}
          accordion
          coverageArea={
            coverageArea?.find(
              (area) => area.coverageAreaId === workingAreasId,
            ) as any
          }
          gasDoPovo={gasDoPovo}
          workingAreaAreaType={workingArea?.type}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default AccordionProductCovered;
